import {
  AddressBookIcon,
  MenuApplicationIcon,
  SecuredIcon,
  SystemRegulationIcon,
  UserPasswordIcon,
} from 'tdesign-icons-react';
import { ReactComponent as Template } from './images/template.svg';
import { ReactComponent as Broker } from './images/broker.svg';
import { ReactComponent as Bookkeeper } from './images/bookkeeper.svg';
import { ReactComponent as Zookeeper } from './images/zookeeper.svg';
import { ReactComponent as Tenant } from './images/tenant.svg';
import { ReactComponent as Namespace } from './images/namespace.svg';
import { ReactComponent as Topic } from './images/topic.svg';
import { ReactComponent as Permissions } from './images/permissions.svg';
import { ReactComponent as Tool } from './images/tool.svg';
import { ReactComponent as Setting } from './images/setting.svg';
import { ReactComponent as PencilAlt } from './images/pencil-alt.svg';
import { ReactComponent as DocumentDuplicate } from './images/document-duplicate.svg';
import { ReactComponent as zoomIn } from './images/zoom-in.svg';
import { ReactComponent as Download } from './images/download.svg';
import { ReactComponent as PresentationChartLine } from './images/presentation-chart-line.svg';
import { ReactComponent as Eye } from './images/eye.svg';
import { ReactComponent as DotsVertical } from './images/dots-vertical.svg';
import { ReactComponent as ArrowCircleLeft } from './images/arrow-circle-left.svg';
import { ReactComponent as ExclamationCircle } from './images/exclamation-circle.svg';
import { ReactComponent as LockClosed } from './images/lock-closed.svg';
import { ReactComponent as Refresh } from './images/refresh.svg';
import { ReactComponent as Filter } from './images/filter.svg';
import { ReactComponent as ChevronDoubleUp } from './images/chevron-double-up.svg';
import { ReactComponent as ArrowCircleRight } from './images/arrow-circle-right.svg';
import { ReactComponent as Terminal } from './images/terminal.svg';
import { ReactComponent as Puzzle } from './images/puzzle.svg';
import { ReactComponent as clusterNor } from './images/cluster_nor.svg';
import { ReactComponent as CubeTransparent } from './images/cube-transparent.svg';
import { ReactComponent as Database } from './images/database.svg';
import { ReactComponent as DesktopComputer } from './images/desktop-computer.svg';
import { ReactComponent as Support } from './images/support.svg';
import { ReactComponent as Chip } from './images/chip.svg';
import { ReactComponent as Code } from './images/code.svg';
import { ReactComponent as Link } from './images/link.svg';
import { ReactComponent as CursorClick } from './images/cursor-click.svg';
import { ReactComponent as PaperClip } from './images/paper-clip.svg';
import { ReactComponent as Ban } from './images/ban.svg';
import { ReactComponent as Clock } from './images/clock.svg';
import { ReactComponent as SolidCircleCheck } from './images/solid-circle-check.svg';
import { ReactComponent as SolidCircleX } from './images/solid-circle-x.svg';
import { ReactComponent as SolidClock } from './images/solid-clock.svg';
import { ReactComponent as DocumentSearch } from './images/document-search.svg';
import { ReactComponent as Pulsar } from './images/pulsar.svg';
import { ReactComponent as Inspect } from './images/inspect.svg';
import { ReactComponent as Bookopen } from './images/book-open.svg';
import { ReactComponent as Fx } from './images/fx.svg';
import { ReactComponent as ComputerEnv } from './images/computer-env.svg';
import { ReactComponent as License } from './images/license.svg';
import { ReactComponent as Checkbox } from './images/checkbox.svg';
import { ReactComponent as Trumpet } from './images/trumpet.svg';
import { ReactComponent as KOP } from './images/kop.svg';

export const svgCmps = {
  template: Template,
  broker: Broker,
  bookkeeper: Bookkeeper,
  zookeeper: Zookeeper,
  tenant: Tenant,
  namespace: Namespace,
  topic: Topic,
  permissions: Permissions,
  tool: Tool,
  setting: Setting,
  'pencil-alt': PencilAlt,
  'document-duplicate': DocumentDuplicate,
  'zoom-in': zoomIn,
  download: Download,
  'presentation-chart-line': PresentationChartLine,
  eye: Eye,
  'dots-vertical': DotsVertical,
  'arrow-circle-left': ArrowCircleLeft,
  'exclamation-circle': ExclamationCircle,
  'lock-closed': LockClosed,
  refresh: Refresh,
  filter: Filter,
  'chevron-double-up': ChevronDoubleUp,
  'arrow-circle-right': ArrowCircleRight,
  terminal: Terminal,
  puzzle: Puzzle,
  cluster_nor: clusterNor,
  'cube-transparent': CubeTransparent,
  support: Support,
  database: Database,
  'desktop-computer': DesktopComputer,
  chip: Chip,
  code: Code,
  link: Link,
  'cursor-click': CursorClick,
  'paper-clip': PaperClip,
  ban: Ban,
  clock: Clock,
  'solid-clock': SolidClock,
  'solid-circle-check': SolidCircleCheck,
  'solid-circle-x': SolidCircleX,
  'document-search': DocumentSearch,
  pulsar: Pulsar,
  inspect: Inspect,
  'book-open': Bookopen,
  'secured-icon': SecuredIcon,
  'user-password-icon': UserPasswordIcon,
  'menu-application-icon': MenuApplicationIcon,
  fx: Fx,
  'address-book': AddressBookIcon,
  'system-regulation': SystemRegulationIcon,
  'computer-env': ComputerEnv,
  license: License,
  checkbox: Checkbox,
  trumpet: Trumpet,
  kop: KOP,
};
